import { Map, List } from 'immutable';
import moment from 'moment';
import {
  isValidCPF,
  isValidCEP,
  isValidEmail,
  isValidPassword,
} from '../../../core/validations';

function validator(data) {
  // Validando e-mail.
  let emailValidationMessage = '';
  const email = data.get('email');
  if (!email) {
    emailValidationMessage = 'Insira um e-mail';
  }
  if (!isValidEmail(email)) {
    emailValidationMessage = 'E-mail inválido';
  }

  // Validando data de nascimento.
  const date = data.get('dataNascimento');
  const dateFormat = 'DD/MM/YYYY';
  const dateBiggerThanToday =
    date &&
    moment(date).diff(moment(moment().format(dateFormat), dateFormat), 'days');
  let dateMessage = '';
  if (!date) {
    dateMessage = 'Insira o dia do nascimento';
  } else if (dateBiggerThanToday > 0) {
    dateMessage = 'Data de nascimento posterior ao dia atual';
  }

  // Validando CPF.
  let cpfMessage = '';
  const cpf = data.get('cpf');
  if (!cpf) {
    cpfMessage = 'Insira um CPF';
  } else if (!isValidCPF(cpf)) {
    cpfMessage = 'CPF inválido';
  }

  // Validando CEP
  let cepMessage = '';
  const cep = data.get('cep');
  if (cep && !isValidCEP(cep)) {
    cepMessage = 'CEP inválido';
  }

  // Validação de senha.
  const password = data.get('senha');
  let passwordMsg = '';
  if (!password) {
    passwordMsg = 'Digite sua senha';
  } else if (!isValidPassword(password)) {
    passwordMsg = 'Senha muito fraca. Tente outra.';
  }

  // Validação de confirmação de senha.
  const confirmation = data.get('confirmacao');
  let confirmationMsg = '';
  if (password && confirmation !== password) {
    confirmationMsg = 'As senhas estão diferentes';
  }

  // Validação de telefone.
  const phones = data.get('telefones');
  let phoneMessage = List([Map({ tipo: '', telefone: '' })]);
  if (phones && phones.size === 0) {
    phoneMessage = phoneMessage
      .setIn([0, 'tipo'], 'Insira o tipo')
      .setIn([0, 'telefone'], 'Insira o número');
  }

  const result = Map({
    nome: data.get('nome') ? '' : 'Insira um nome',
    apelido: data.get('apelido') ? '' : 'Insira um apelido',
    email: emailValidationMessage,
    cpf: cpfMessage,
    cep: cepMessage,
    sexo: data.get('sexo') ? '' : 'Selecione um sexo',
    numero: data.get('numero') ? '' : 'Insira o número do imóvel',
    dataNascimento: dateMessage,
    senha: passwordMsg,
    confirmacao: confirmationMsg,
    telefones: phoneMessage,
  });

  return result;
}

export default validator;
